module.exports = __webpack_public_path__ + "64039f43a5c2b98b312bc9f7c74656e1.fbx";